module.exports = __webpack_public_path__ + "media/images/map_icons/Golf-4e7a786d000cbac5ec5026c73fe4af72.svg";